import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { SharedService } from '../services/shared.service';
import { SESSION_STORAGE_KEYS } from '../types/types';

@Injectable({
  providedIn: 'root'
})
export class SessionGuard implements CanActivate {

  constructor(private router: Router, private sharedService: SharedService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    // if (!this.isAuthenticated()) {
      // this.sharedService.clearSessionStorage('LOCAL')
      // this.sharedService.clearSessionStorage('SESSION')
      // return true
    // }
    this.sharedService.clearSessionStorage('LOCAL')
    return true
    // return this.router.createUrlTree(['/register',this.sharedService.getDataFromSessionStorage(SESSION_STORAGE_KEYS.USER_ID)]);
  }

  private isAuthenticated(): boolean {
    return !!(
      this.sharedService.getDataFromSessionStorage(SESSION_STORAGE_KEYS.SESSION_TOKEN) &&
      this.sharedService.getDataFromSessionStorage(SESSION_STORAGE_KEYS.TENANT_DETAILS,'SESSION')
    );
  }
}
